import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class DonutBadge extends WritingBadge {
  public readonly id = BadgeId.donut;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.wordsCount >= 6000;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/donut.ts